export default "__VITE_ASSET__52069f96__"